import { render } from "./CadastroOrcamento.vue?vue&type=template&id=2c6c7b04&scoped=true"
import script from "./CadastroOrcamento.vue?vue&type=script&lang=ts"
export * from "./CadastroOrcamento.vue?vue&type=script&lang=ts"

import "./CadastroOrcamento.vue?vue&type=style&index=0&id=2c6c7b04&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c6c7b04"

export default script